{
  "title": "Вход и безопасность",
  "required": "Чтобы продолжить, добавьте passkey или приложение-аутентификатор. Второй фактор нужен всем, включая гостей.",
  "passkeys": "Passkeys",
  "passkeysLead": "Вход без пароля с помощью вашего устройства или аппаратного ключа.",
  "addPasskey": "Добавить passkey",
  "passkeyName": "Название passkey",
  "passkeyNameDefault": "Моё устройство",
  "noPasskeys": "Passkeys пока нет.",
  "lastUsed": "Использован {{date}}",
  "neverUsed": "Ещё не использовался",
  "synced": "Синхронизируется",
  "deviceBound": "Только это устройство",
  "totp": "Приложение-аутентификатор",
  "totpLead": "Коды из Google Authenticator, 1Password, Aegis и подобных — вместе с паролем.",
  "totpEnabled": "Включено",
  "totpSetup": "Настроить",
  "totpScan": "Отсканируйте код в приложении или введите ключ вручную, затем введите 6-значный код.",
  "totpKey": "Ключ",
  "totpConfirm": "Подтвердить",
  "totpDisable": "Отключить",
  "recoveryTitle": "Сохраните коды восстановления",
  "recoveryLead": "Каждый код срабатывает один раз, если вы потеряете приложение-аутентификатор. Они показываются только сейчас.",
  "recoveryDone": "Я их сохранил(а)",
  "intro": "Как вы входите в CloudServer. По возможности используйте passkey и держите запасной способ на случай потери устройства.",
  "removePasskeyTitle": "Удалить passkey «{{name}}»?",
  "removePasskeyEffect": "Войти с ним на том устройстве больше не получится.",
  "removePasskeyKeep": "Ключ может остаться в менеджере паролей или на устройстве; здесь он просто перестанет работать.",
  "totpDisableTitle": "Отключить приложение-аутентификатор?",
  "totpDisableEffect": "При входе по паролю код больше не будет запрашиваться.",
  "totpDisableCodes": "Коды восстановления перестанут работать."
}
